import React from 'react';
import { useNavigate } from 'react-router-dom';
import ParallaxImage from '../motion/ParallaxImage';
import '../motion/motion.css';
import './CTASection.css';

const CTASection = () => {
  const navigate = useNavigate();

  const handleContactClick = (e) => {
    e.preventDefault();
    navigate('/contact');
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  return (
    <section className="cta-section section">
      <div className="container">
        <div className="cta-layout">
        <div className="cta-content">
          <div className="cta-header">
            <h2 className="cta-title">
              Need an AI product shipped, <span className="logo-highlight">not a slide deck?</span>
            </h2>
            <p className="cta-subtitle">
              Send us what you are building. Senior engineers reply, on the same stack we run in production. No discovery funnel, no boilerplate proposal.
            </p>
          </div>

          <div className="cta-buttons">
            <button onClick={handleContactClick} className="cta-clean-btn">
              Tell us what you are building
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </button>
            <a href="mailto:info@pysolutions.dev" className="cta-clean-btn cta-clean-btn-secondary">
              Email info@pysolutions.dev
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8m-2 11H5a2 2 0 01-2-2V7a2 2 0 012-2h14a2 2 0 012 2v10a2 2 0 01-2 2z" />
              </svg>
            </a>
          </div>
          <div className="cta-features">
            <div className="cta-feature">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              <span>Senior engineer replies within 24 h</span>
            </div>
            <div className="cta-feature">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span>Reference stack, named technologies</span>
            </div>
            <div className="cta-feature">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
              <span>NDA-friendly, GDPR by location</span>
            </div>
          </div>

          <div className="cta-linkedin">
            <a
              href="https://www.linkedin.com/company/pysolutions-dev"
              target="_blank"
              rel="noopener noreferrer"
              className="cta-linkedin-link"
              aria-label="Follow PySolutions on LinkedIn"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
              Follow on LinkedIn
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5-5 5M6 12h12" />
              </svg>
            </a>
          </div>
        </div>
        <ParallaxImage className="cta-visual" src="/media/cta-tower.webp" amount={28} />
        </div>
      </div>
    </section>
  );
};

export default CTASection;
